import { Control, useWatch } from 'react-hook-form'
import { /* CheckboxInput, */ CustomCheckboxInput, Label, QuestionCard, YStack, generateIconInput } from '@my/ui'
import { DropdownField, InputField } from '../helpers/Helper'
import images from '../../../assets/images'
import { Percent } from '@tamagui/lucide-icons-2'
import { April2026UpdatedOptions, confirmationOptions } from '../data'
import { FinancialSecurity } from './FinancialSecurity'

interface RetirementPlanningProps {
  control: Control<any>
}

const CashInput = (
    controllerOptions,
    inputOptions = undefined as any,
  ) => {
    return <InputField
              control={controllerOptions.control}
              name={controllerOptions.name}
              placeholder={inputOptions?.placeholderText || inputOptions?.label}
              label={inputOptions?.label}
              icon={images.money}
            />
}

const PercentageInput = (
  controllerOptions,
  inputOptions = undefined as any,
) => {
  return <InputField
            control={controllerOptions.control}
            name={controllerOptions.name}
            placeholder={inputOptions?.placeholderText || inputOptions?.label}
            label={inputOptions?.label}
            lucideIcon={<Percent color='rgb(133, 193, 157)' height={15} width={15}/>}
            iconPosition="right"
          />
}

const CheckboxInput = (
  controllerOptions,
  inputOptions = undefined as any,
) => {
  return <YStack>
    {inputOptions?.label ? <Label>{inputOptions?.label}</Label> : null}
    <CustomCheckboxInput
      options={confirmationOptions} // Checkbox options for dependents
      control={controllerOptions.control}
      name={controllerOptions.name}
    />
  </YStack>
}

export const RetirementPlanning: React.FC<RetirementPlanningProps> = ({ control }) => {
  const isActivelyContributing = useWatch({ name: 'Investing - IRA/Other - Actively Contributing'});
  const haveMaxedIRA = useWatch({ name: 'Investing - IRA - Annual Contribution Max Reached'});
  //const CashInput = generateIconInput('cash')
  //const PercentageInput = generateIconInput('percentage')
  return (
    <>
      
        <QuestionCard questionGroupTitle="How would you describe your experience with investing?">
          <DropdownField
            control={control}
            name="Investing - Personal experience level"
            items={April2026UpdatedOptions['Retirement Planning'].investmentExperience}
            native
          />
        </QuestionCard>
        <QuestionCard questionGroupTitle='How much (%) are you putting in your 401K each paycheck?'>
        {PercentageInput(
          { control, name: 'Investing - 401k - Personal Contribution Percentage' },
          //{ label: 'How much (%) are you putting in your 401K each paycheck?' }
        )}
        </QuestionCard>
        <QuestionCard questionGroupTitle='How much (%) does your employer match annually?'>
        {PercentageInput(
          { control, name: 'Investing - 401k - Employer Contribution Percentage' },
          //{ label: 'How much (%) does your employer match annually?' }
        )}
        </QuestionCard>
        <QuestionCard questionGroupTitle="What is your employer’s matching formula?">
          <DropdownField
            control={control}
            name="Investing - 401k - Employer Contribution Formula"
            items={April2026UpdatedOptions['Retirement Planning'].employerMatchFormula}
            native
          />
        </QuestionCard>
        <QuestionCard questionGroupTitle="Does your 401(k) plan allow after-tax (non-Roth) contributions beyond the standard limit?">
          <DropdownField
            control={control}
            name="Investing - 401k - Allows after-tax (non-Roth) contributions"
            items={April2026UpdatedOptions['Retirement Planning'].genericYesNoNotSure}
            native
          />
        </QuestionCard>
        <QuestionCard questionGroupTitle='Do you contribute to personal investment accounts (including IRA)?'>
        {CheckboxInput(
          { control, name: 'Investing - IRA/Other - Actively Contributing' },
          //{ label: 'Do you contribute to personal investment accounts (including IRA)?' }
        )}
        </QuestionCard>
        {isActivelyContributing && <>
          <QuestionCard questionGroupTitle='Have you maxed out your IRA for this year ($7,500)?'>
          {CheckboxInput(
            { control, name: 'Investing - IRA - Annual Contribution Max Reached' },
            //{ label: 'Have you maxed out your IRA for this year ($7,000)?' }
          )}
          </QuestionCard>
          {haveMaxedIRA && <QuestionCard questionGroupTitle='If not, how much have you already contributed to your IRA for this year?'>
          {CashInput(
            { control, name: 'Investing - IRA - Contribution Progress' },
            {
              //label: 'If not, how much have you already contributed to your IRA for this year?',
            }
          )}
          </QuestionCard>}
        </>}
        <FinancialSecurity {...{control}} />
        
        {/* <QuestionCard questionGroupTitle='How much do you contribute to investment accounts per month, including IRA accounts?'>
        {CashInput(
          { control, name: 'Investing - Monthly - Contribution' },
          {
            //label: 'How much do you contribute to investment accounts per month, including IRA accounts?',
          }
        )}
      </QuestionCard> */}
    </>
  )
}
